import React from 'react'

const Home = () => {
  return (
    <div>
      <h1>Navigating the 2023 Recession: Impact on Placement Season</h1>
      <p>
        In the wake of the global economic landscape, the year 2023 brought with it unprecedented challenges and shifts. As educational institutions and industries alike grappled with the effects of a recession, the placement season underwent significant transformations.
      </p>
      <br/>
      <p>
        We invite you to be a part of a crucial exploration into the nexus of academia and economic downturn. This survey aims to capture the firsthand experiences, insights, and adaptations made by students, institutions, and employers during this period of economic turbulence.
      </p>
      <br/>

      <p>
        Your participation in this survey is instrumental in shedding light on the multifaceted impacts of the recession on the placement season of 2023. By sharing your experiences, you contribute to a collective understanding that will be invaluable for future generations of students, institutions, and recruiters.
      </p>
      <br/>

      <p>
        Rest assured, all responses will be treated with the utmost confidentiality and aggregated data will be used solely for research purposes. Your candid and thoughtful input will be the cornerstone of a comprehensive analysis that aims to inform and guide stakeholders in education and industry.
      </p>
      <br/>

      <p>
        Thank you for your invaluable contribution to this study. Together, we embark on a journey to unearth the lessons and resilience forged amidst adversity.
      </p>
    </div>
  )
}

export default Home
